export enum OdometerUnitEnum {
  Miles=1,
  Kilometres=2
}
